import { adminRole, AdminRoles } from '@/configs/role';

export const getRoleById = (roleId: number) => {
  const role = adminRole.find((aRole) => aRole.code === roleId);

  return role || null;
};

export const roleIsHigherThen = (roleId: number, code: AdminRoles, equal = false) => {
  if (equal === true) {
    return roleId <= code;
  }

  return roleId < code;
};
